import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageSalesOrder from 'Pages/sales-order';

const SalesOrder = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Route exact path={`${match.url}/:page`} component={ PageSalesOrder } />
			<Redirect exact from={ match.url } to={`${match.url}/salesman`} />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default SalesOrder;